import api from "./index";

export async function signIn(body) {
  return api.post("/auth/local/admin", body);
}

export async function fetchUser() {
  return api.get("/auth");
}

export async function signOut() {
  return api.delete("/auth/sign-out");
}
